var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Thing } from 'lincd-schema/shapes/Thing';
import { irlcg } from '../../ontologies/irlcg.js';
import { linkedShape } from '../../package.js';
let ScoreConfiguration = class ScoreConfiguration extends Thing {
    calculateTotalScore(action, userTopicActions, totalScore, medalTemplateIds, medalScore) {
        return 0;
    }
};
ScoreConfiguration.targetClass = irlcg.ScoreConfiguration;
ScoreConfiguration = __decorate([
    linkedShape({
        description: 'A configuration defining how scores are calculated for action. (scoring, algorithm, configuration)',
    })
], ScoreConfiguration);
export { ScoreConfiguration };
//# sourceMappingURL=ScoreConfiguration.js.map